<template>
      <el-form label-width="130px" style="height: 800px">
      <el-row v-for="item in materialList" :key="item.nanoid">
        <el-col :span="24" style="margin-bottom: 5px;padding-top: 6px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="物品编码：" >
                <el-select v-model="item.material_id" placeholder="请选择物品编码" class="form-item" clearable>
                  <el-option v-for="dict in materialIdList" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" >
              <el-form-item label="入库数量：" class="form-item">
                <el-input-number v-model="item.cnt" :step="1" :min="1"/>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="备注：" >
                <el-input v-model="item.remark" placeholder="备注" class="form-item" clearable></el-input>
              </el-form-item>
              <div class="close" @click="removeOneMaterial(item.nanoid)">
                <el-icon>
                  <ElIconClose></ElIconClose>
                </el-icon>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="text-align: center">
        <el-button @click="addOneMaterial()"  plain>添加三个物品</el-button>
        <el-button @click="submit" :loading="loading"  plain>确认提交</el-button>
        </el-col>
      </el-row>
      </el-form>

</template>

<script>
import {nanoid} from 'nanoid';

export default {
  name: "PurchaseManage",
  emits: ['submitted'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        materialId: '',
        articles:'',
        remark:''
      },
      materialIdList:[],
      materialList: [],
      loading: false
    }
  },
  computed: {

  },
  created() {
    this.addFiveProduct()
    this.getMaterialIdList();
  },
  methods: {
    reset() {
      this.clearPreData()
      this.$refs.commitMessage.clear()
    },
    clearPreData() {
      //清空表单数据
      this.materialList = []
    },
    //获取物品编码以及名称
    getMaterialIdList(){
      this.$axios.get('purchase/getMaterialIdList').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error(res.message);
        }
        this.materialIdList = res.data;
        this.$emit('submitted')
      }, error => {
        this.loading = false;
        this.this.$message.error(`提交失败，${error.message}`);
      })
    },
    submit() {
        var  a = 0;
        for (let i = 0; i < this.materialList.length; i++) {
          let obj = this.materialList[i]

          if (!obj.material_id) {
            a = a + 1;
          }
        }

        if (a === this.materialList.length){
          return this.$message.error("数据为空");
        }

       this.loading = true;
       this.$axios.post('purchase/addPurchase',this.materialList).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code != 0) {
          return this.$message.error(res.message);
        }

        this.$message.success("新增成功");
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
        this.clearPreData()
      }, error => {
        this.loading = false;
        this.$message.error(`提交失败，${error.message}`);
      })
    },
    addOneMaterial() {
      this.materialList.push({
        nanoid: nanoid(),
        cnt:1
      }),
      this.materialList.push({
        nanoid: nanoid(),
        cnt:1
      }),
      this.materialList.push({
      nanoid: nanoid(),
        cnt:1
      })
    },
    removeOneMaterial(nanoid) {
      let index = this.materialList.findIndex(item => item.nanoid === nanoid);
      this.materialList.splice(index, 1);
    },
    addFiveProduct() {
      for (let i = 0; i < 6; i++) {
        this.materialList.push({
          nanoid: nanoid(),
          cnt:1
        })
      }
    },
  }
}
</script>

<style scoped>
.form-item {
  width: 250px;
}

.close {
  position: absolute;
  top: 4px;
  right: 16px;
  font-size: 18px;
  cursor: pointer;
}

</style>